import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import { Labels as Labels$2, Label } from './Labels.styles.js';
import useRect from '../../../../hooks/useRect.js';
import { FadeIn } from '../../../Animations/FadeIn/FadeIn.js';

var Labels = function Labels(_ref) {
  var labels = _ref.labels,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$isReversed = _ref.isReversed,
    isReversed = _ref$isReversed === void 0 ? false : _ref$isReversed;
  var _useRect = useRect(),
    _useRect2 = _slicedToArray(_useRect, 2),
    ref = _useRect2[0],
    width = _useRect2[1].width;
  var scaleFactor = width / (max - min);
  return React__default.createElement(FadeIn, null, React__default.createElement(Labels$2, {
    $isDisabled: isDisabled,
    $isReversed: isReversed,
    ref: ref
  }, labels.map(function (_ref2) {
    var hasNotch = _ref2.hasNotch,
      label = _ref2.label,
      position = _ref2.position;
    var labelText = label || position;
    return React__default.createElement(Label, {
      key: position,
      $isReversed: isReversed,
      $hasNotch: hasNotch,
      $min: min,
      $scaleFactor: scaleFactor,
      label: labelText,
      value: position
    }, labelText);
  })));
};
Labels.propTypes = {
  isDisabled: PropTypes.bool,
  isReversed: PropTypes.bool,
  labels: PropTypes.arrayOf(PropTypes.shape({
    hasNotch: PropTypes.bool,
    label: PropTypes.string,
    position: PropTypes.number.isRequired
  })).isRequired,
  max: PropTypes.number,
  min: PropTypes.number
};
var Labels$1 = Labels;

export { Labels$1 as default };
//# sourceMappingURL=Labels.js.map
